export enum ModuleType {
  SDI = 'SDI',
  PPM = 'PPM',
  HSES = 'HSES',
  TA_COMMITMENTS = 'TA_COMMITMENTS',
  TA_FUNDING_INSTRUMENTS = 'TA_FUNDING_INSTRUMENTS',
  FINANCIAL_RISK = 'FINANCIAL_RISK',
  ADMIN = 'ADMIN',
  DATA_ADMIN = 'DATA_ADMIN',
}